import * as React from "react";
import { useContext, useState } from "react";
import WidgetEditApplyAllChangesContext from "views/components/contexts/WidgetEditApplyAllChangesContext";
import { ModalSubmit } from "components/common";
import DisableSubmissionStateContext from "views/components/contexts/DisableSubmissionStateContext";
export const UPDATE_WIDGET_BTN_TEXT = "Update widget";
const SaveOrCancelButtons = ({ onCancel }) => {
  const { applyAllWidgetChanges } = useContext(WidgetEditApplyAllChangesContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { disabled: disabledSubmit } = useContext(DisableSubmissionStateContext);
  const _onSubmit = () => {
    setIsSubmitting(true);
    return applyAllWidgetChanges().then(() => {
      setIsSubmitting(false);
    }).catch(() => {
      setIsSubmitting(false);
    });
  };
  return /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      isAsyncSubmit: true,
      submitButtonText: UPDATE_WIDGET_BTN_TEXT,
      submitLoadingText: "Updating widget...",
      onSubmit: _onSubmit,
      submitButtonType: "button",
      disabledSubmit,
      isSubmitting,
      displayCancel: true,
      onCancel
    }
  );
};
export default SaveOrCancelButtons;
